module.exports = __webpack_public_path__ + "img/agv5.da40f3d4.jpg";